import * as React from 'react';
import { Props } from '..';

const Feedback: React.FC<Props> = ({
  color = 'currentColor',
  strokeWidth = 2,
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.51563 11.0625C7.32292 11.0625 7.15755 10.9935 7.01953 10.8555C6.88151 10.7174 6.8125 10.5521 6.8125 10.3594C6.8125 10.1667 6.88151 10.0013 7.01953 9.86328C7.15755 9.72526 7.32292 9.65625 7.51563 9.65625C7.70833 9.65625 7.8737 9.72526 8.01172 9.86328C8.14974 10.0013 8.21875 10.1667 8.21875 10.3594C8.21875 10.487 8.1862 10.6042 8.12109 10.7109C8.05859 10.8177 7.97396 10.9036 7.86719 10.9687C7.76302 11.0313 7.64583 11.0625 7.51563 11.0625ZM10.5449 11.0625C10.3522 11.0625 10.1868 10.9935 10.0488 10.8555C9.91081 10.7174 9.8418 10.5521 9.8418 10.3594C9.8418 10.1667 9.91081 10.0013 10.0488 9.86328C10.1868 9.72526 10.3522 9.65625 10.5449 9.65625C10.7376 9.65625 10.903 9.72526 11.041 9.86328C11.179 10.0013 11.248 10.1667 11.248 10.3594C11.248 10.487 11.2155 10.6042 11.1504 10.7109C11.0879 10.8177 11.0033 10.9036 10.8965 10.9687C10.7923 11.0313 10.6751 11.0625 10.5449 11.0625ZM13.5742 11.0625C13.3815 11.0625 13.2161 10.9935 13.0781 10.8555C12.9401 10.7174 12.8711 10.5521 12.8711 10.3594C12.8711 10.1667 12.9401 10.0013 13.0781 9.86328C13.2161 9.72526 13.3815 9.65625 13.5742 9.65625C13.7669 9.65625 13.9323 9.72526 14.0703 9.86328C14.2083 10.0013 14.2773 10.1667 14.2773 10.3594C14.2773 10.487 14.2448 10.6042 14.1797 10.7109C14.1172 10.8177 14.0326 10.9036 13.9258 10.9687C13.8216 11.0313 13.7044 11.0625 13.5742 11.0625Z"
      fill={'white'}
    />
    <path
      d="M19 9.50001C19.0034 10.8199 18.695 12.1219 18.1 13.3C17.3944 14.7118 16.3097 15.8992 14.9674 16.7293C13.6251 17.5594 12.0782 17.9994 10.5 18C9.18012 18.0034 7.8781 17.6951 6.69999 17.1L1 19L2.9 13.3C2.30493 12.1219 1.99656 10.8199 2 9.50001C2.00061 7.92177 2.44061 6.37487 3.27072 5.03257C4.10082 3.69027 5.28825 2.60559 6.69999 1.90003C7.8781 1.30496 9.18012 0.996587 10.5 1.00003H11C13.0843 1.11502 15.053 1.99479 16.5291 3.47088C18.0052 4.94698 18.885 6.91567 19 9.00002V9.50001Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Feedback;
